import Vue from 'vue/dist/vue.js';
import App from './App.vue';
import router from './router';
import { firestorePlugin } from 'vuefire';
import axios from 'axios'
import VueAxios from 'vue-axios'
import lazysizes from "lazysizes";

Vue.use(firestorePlugin);
Vue.use(VueAxios, axios);
Vue.use(lazysizes);

Vue.config.productionTip = false;
Vue.config.runtimeCompiler = true;

window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.init          = false;
window.lazySizesConfig.lazyClass     = 'js-lazy';
window.lazySizesConfig.expand        = 450;
window.lazySizesConfig.expFactor     = 1.3;

new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
});